<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!-- 임시저장 -->
					<sf-button line size="sm" icon="file" color="info" :onClick="() => saveAction('0')" v-if="isButton_(scrId, 'TS') && showSaveBtn">
						{{ getButtonMsg_(scrId, 'TS') }}
					</sf-button>
					<!-- 작성 -->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('20')" v-if="isButton_(scrId, 'WR') && showRegBtn">
						{{ getButtonMsg_(scrId, 'WR') }}
					</sf-button>
					<!-- 검토 -->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('30')" v-if="isButton_(scrId, 'IP') && showIspBtn">
						{{ getButtonMsg_(scrId, 'IP') }}
					</sf-button>
					<!-- 승인 -->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('40')" v-if="isButton_(scrId, 'CS') && showCsetBtn">
						{{ getButtonMsg_(scrId, 'CS') }}
					</sf-button>
					<!-- 반려 -->
					<sf-button
						line
						size="sm"
						icon="circle-close"
						color="error"
						:onClick="() => saveAction('10')"
						v-if="isButton_(scrId, 'GV') && showRejectBtn"
					>
						{{ getButtonMsg_(scrId, 'GV') }}
					</sf-button>
					<!-- 삭제 -->
					<sf-button line size="sm" icon="trash" color="error" :onClick="deleteAction" v-if="isButton_(scrId, 'CD') && showDeleteBtn">
						{{ getButtonMsg_(scrId, 'CD') }}
					</sf-button>
					<!-- 이메일 전송 -->
					<!-- <sf-button line size="sm" icon="mail" :onClick="sendEmail" v-if="isButton_(scrId, 'SD') && detailForm.sndStCd !== 'SND_CMPL'">
						{{ getButtonMsg_(scrId, 'SD') }}
					</sf-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		saveAction(pgsStCd) {
			const rollbackCode = this.detailForm.pgsStCd;
			let confirmMsg = '';
			try {
				if (!this.user.email) {
					throw new Error(this.getMessage_('QWCC001791')); //사용자 관리 페이지에서 이메일 정보를 먼저 작성해주세요.
				}
				if (pgsStCd === '0') {
					//임시 저장일 떄
					confirmMsg = 'QWCC001787';
					this.setDetailForm_({ key: 'sndStCd', value: 'TMP_STG' }); //임시저장
					this.schemaSave.validateSync(this.detailForm);
					if (this.rcptInfo.size < 1) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000047')])); //신청처는 필수값
					}
					if (this.rfpInfo.size < 1) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000049')])); //담당부서는 필수값
					}
				} else if (pgsStCd == 10) {
					// 검토반려(10) 일 때 검토 비고 필수
					confirmMsg = 'QWCC001788';
					if (!this.detailForm.rmk) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001527')]));
					}
					// 오류로 이메일이 저장되지 않은 상태로 진행되었을 경우, 반려하기 위해서 작성자의 이메일을 넣어준다.
					if (!this.detailForm.rcptNm || !this.detailForm.rcptAdr) {
						// 글쓴이를 수신처로
						this.detailForm.rcptNm = this.detailForm.dsprNm;
						this.detailForm.rcptAdr = this.detailForm.dsprAdr;
						// 현 작성사를 발신자로
						this.detailForm.dsprNm = this.user.userName;
						this.detailForm.dsprAdr = this.user.email;
					}
					this.setDetailForm_({ key: 'sndStCd', value: 'NSND' }); //미발송
				} else if (pgsStCd > 10) {
					// 작성(20) 검토(30) 승인 (40)
					if (pgsStCd == 20) confirmMsg = 'QWCC001794';
					if (pgsStCd == 30) confirmMsg = 'QWCC001785';
					if (pgsStCd == 40) confirmMsg = 'QWCC001786';
					this.schemaReg.validateSync(this.detailForm);
					this.extraValidate();
					this.setDetailForm_({ key: 'sndStCd', value: 'NSND' }); //미발송
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_(confirmMsg),
					buttons: [{ title: 'Ok', clickFn: () => this.middleAction(pgsStCd, rollbackCode) }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		middleAction(pgsStCd, rollbackCode) {
			pgsStCd && this.setDetailForm_({ key: 'pgsStCd', value: pgsStCd });
			if (pgsStCd < 50) this.save(rollbackCode);
			else this.update(rollbackCode);
		},
		/**저장 로직 */
		async save(rollbackCode) {
			try {
				this.$sf_toggleLoading(true);
				const {
					header: { code, messageCd },
					body
				} = await this.saveData_(this.detailFormData_);
				const value = Object.assign({}, this.detailForm, body);
				this.setState_({ key: 'detailForm', value });
				this.commonAfterSave(code, messageCd, rollbackCode);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/** 업데이트 로직 */
		async update(rollbackCode) {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.updateData_(this.detailFormUpdate_);
				// const { code, messageCd } = await this.updateData1_(this.detailFormData_);
				this.commonAfterSave(code, messageCd, rollbackCode);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		deleteAction() {
			try {
				const { partNo, altrNo } = this.detailForm;
				if (!partNo || !altrNo) {
					throw new Error(this.getMessage_('QWCC001197'));
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001196'),
					buttons: [{ title: 'Ok', clickFn: this.delete }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
			}
		},
		async delete() {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.deleteData_(this.detailFormUpdate_);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.$emit('deleteFin');
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001404') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		setInitForm() {
			this.setPopupInit_();
		},
		refresh() {
			this.$emit('refresh');
		},
		sendEmail() {
			try {
				this.schemaReg.validateSync(this.detailForm);
				this.extraValidate();
				if (this.detailForm.pgsStCd && this.detailForm.pgsStCd >= 20) {
					if (this.detailForm.sndStCd !== 'SND_CMPL') {
						this.setDetailForm_({ key: 'sndStCd', value: 'NSND' });
						this.setDetailForm_({ key: 'dsprNm', value: this.user.userName });

						if (!this.detailForm.rmk) this.setDetailForm_({ key: 'rmk', value: 'User sent the email.' });

						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_('QWCC001513'),
							buttons: [{ title: 'Ok', clickFn: () => this.save(this.detailForm.pgsStCd) }]
						});
					}
				} else {
					throw new Error(this.getMessage_('QWCC001526'));
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		/** 저장 공통 로직 ; 에러 체크 혹은 정상 저장 시 새로고침 */
		commonAfterSave(code, messageCd, rollbackCode) {
			if (code === 0 || code === 3) {
				this.$sf_toast({
					type: code === 0 ? 'ok' : 'error',
					message: this.getMessage_(messageCd)
				});
			}
			code === 0 && this.refresh();
			code === 3 && this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode }); //실패시 다시 복구
		},
		/** yup으로 못하는 검증 */
		extraValidate() {
			const { altrPreFile, altrPreFileDb, altrAftFile, altrAftFileDb } = this.detailForm;
			if (this.rcptInfo.size < 1) {
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000047')]));
			}
			if (this.rfpInfo.size < 1) {
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000049')]));
			}
			if (this.altrLgrpList?.length) {
				if (!this.detailForm.altrPrvsLgrpCd)
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000030')]));
			}
			if (this.altrSgrpList?.length) {
				if (!this.detailForm.altrPrvsSgrpCd)
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000035')]));
			}
			if (this.detailForm.partClCd === 'RC') {
				//양산품일 때, 변경 전 사양 필수
				if (!this.isValidObject(altrPreFile) && !this.isValidObject(altrPreFileDb))
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000044')]));
			}
			if (!this.isValidObject(altrAftFile) && !this.isValidObject(altrAftFileDb)) {
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000045')]));
			}
		},
		isValidObject(file) {
			if (!file) return false;
			return file.size > 0 || file.fileSize > 0;
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		showDeleteBtn() {
			//삭제 버튼 (작성자 본인만 가능)
			// return (this.isPqyGuest || this.isPqyStaff) && 
			// return this.isWriterSelf_ && this.detailForm.altrNo && this.detailForm.pgsStCd <= 20;
			var delBtn = false;
			if(this.detailForm.altrNo){
				if (this.detailForm.pgsStCd == 30) {
					delBtn = this.isPqyAdmin;
				} else if (this.detailForm.pgsStCd == 20) {
					delBtn = this.isPqyManager ;
				} else if (this.detailForm.pgsStCd < 20){
					delBtn = this.isPqyAdmin || this.isPqyManager;
				}
			}
			
			return delBtn;
		},
		showSaveBtn() {
			//임시저장 권한 (외부사용자, 업무담당자)
			// return (this.isPqyGuest || this.isPqyStaff) && 
			return this.isWriterSelf_ && this.detailForm.pgsStCd < 20;
		},
		showRegBtn() {
			//작성 권한 (외부사용자, 업무담당자)
			// return (this.isPqyGuest || this.isPqyStaff) &&
			return this.isWriterSelf_ && this.detailForm.pgsStCd <= 20;
		},
		showIspBtn() {
			//검토 권한 (중간관리자)
			// return this.isPqyManager && 
			return this.detailForm.pgsStCd == 20;
		},
		showCsetBtn() {
			//승인 권한 (관리자)
			// return this.isPqyAdmin && 
			return this.detailForm.pgsStCd == 30;
		},
		showRejectBtn() {
			//반려권한
			//console.log(this.isPqyAdmin);
			//console.log(this.isPqyManager);
			// if (this.isPqyAdmin) {
			// 	return !!(this.detailForm.pgsStCd == 30);
			// } else if (this.isPqyManager) {
			// 	return !!(this.detailForm.pgsStCd == 20);
			// } else return false;
			var showBtn = false;
			if (this.detailForm.pgsStCd == 30) {
				showBtn = this.isPqyAdmin;
			} else if (this.detailForm.pgsStCd == 20) {
				showBtn = this.isPqyManager ;
			} 
			return showBtn;
			
		},
		schemaSave() {
			return Yup.object().shape({
				partNo: Yup.string().required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')])),
				altrTypeCd: Yup.string().required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001086')])),
				partClCd: Yup.string().required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000033')])),
				altrPurpSbc: Yup.string()
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000043')]))
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000043')])), //{0}은(는) 팔수 입력 값 입니다. ,
				altrSbc: Yup.string()
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000046')]))
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000046')])), //{0}은(는) 팔수 입력 값 입니다.
				altrDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('MWPO000038')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('MWPO000038')])) //{0}은(는) 팔수 입력 값 입니다. ,
			});
		},
		schemaReg() {
			return Yup.object().shape({
				partNo: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')])), //{0}은(는) 팔수 입력 값 입니다. ,
				altrDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('MWPO000038')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('MWPO000038')])), //{0}은(는) 팔수 입력 값 입니다. ,
				altrDlvgDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000034')])) //{0}은(는) 팔수 입력 값 입니다. ,
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000034')])), //{0}은(는) 팔수 입력 값 입니다. ,
				vrfDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000032')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000032')])), //{0}은(는) 팔수 입력 값 입니다. ,
				trwiDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000037')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000037')])), //{0}은(는) 팔수 입력 값 입니다. ,
				partClCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000033')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000033')])), //{0}은(는) 팔수 입력 값 입니다. ,
				// vrfRsltCd: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000040')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000040')])),
				//{0}은(는) 팔수 입력 값 입니다. ,
				altrTypeCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001086')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001086')])), //{0}은(는) 팔수 입력 값 입니다. ,
				altrPurpSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000043')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000043')])), //{0}은(는) 팔수 입력 값 입니다. ,
				// vrfSbc: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000038')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000038')])), //{0}은(는) 팔수 입력 값 입니다. ,
				altrSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000046')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000046')])), //{0}은(는) 팔수 입력 값 입니다.
				dsprNm: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001522')])) // 발신처 이름
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001522')])), // 발신처 이름
				dsprAdr: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001523')])) // 발신처 이메일
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001523')])) // 발신처 이메일
			});
		}
	}
};
</script>

<style lang="scss" scoped></style>
